import { Popover } from 'antd';
import React, { useState } from 'react';
import styles from './moreEvent.module.scss';
import EventCell from './EventCell';
import { getIn18Text } from 'api';
const MoreEvent = ({ num, events, judgePast = true }) => {
    const [visible, setVisible] = useState(false);
    const eventNum = events.length - num + 1;
    const renderContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    height: 44,
                    lineHeight: '44px',
                    padding: '0 8px',
                    fontSize: '12px',
                    color: 'rgba(38, 42, 51, 0.9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                } },
                getIn18Text('QUANBURICHENG'),
                React.createElement("span", { onClick: () => {
                        setVisible(false);
                    }, className: styles.close })),
            events.map(i => (React.createElement("div", { className: styles.eventOuter, key: i.scheduleId },
                React.createElement(EventCell, { event: i, judgePast: judgePast }))))));
    };
    const onVisibleChange = visible => {
        setVisible(visible);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Popover, { arrowPointAtCenter: true, destroyTooltipOnHide: true, getPopupContainer: () => document.body, placement: "bottom", trigger: "click", content: renderContent, visible: visible, onVisibleChange: onVisibleChange, overlayInnerStyle: {
                width: 220,
                maxHeight: 280,
                padding: '0 8px 16px 12px',
            } },
            React.createElement("div", { className: styles.eventOuter, style: { textAlign: 'left' } },
                React.createElement("span", { className: styles.moreTitle },
                    getIn18Text('HAISHENG'),
                    eventNum,
                    getIn18Text('GERICHENG'))))));
};
export default MoreEvent;
